// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__32yRD","inputWrap":"CustomTip_inputWrap__TiATM"};